/* eslint-disable array-callback-return */

export const parseRelevantTables = (staticTriggerFields, serviceName) => {
    let relevantTables = [];

    staticTriggerFields.map((stf) => {
        if (stf.displayName === serviceName && !relevantTables.includes(stf.tableDisplayName)) {
            relevantTables.push(stf.tableDisplayName);
        }
    });

    return relevantTables;
}

export const parseRelevantFields = (staticTriggerFields, tableName) => {
    let relevantFields = [];

    staticTriggerFields.map((stf) => {
        if (stf.tableDisplayName === tableName) {
            relevantFields.push({ triggerServiceId: stf.triggerServiceId, fieldDisplayName: stf.fieldDisplayName, isEnumerable: stf.isEnumerable, enumSourceTable: stf.enumSourceTable });
        }
    });

    return relevantFields;
}

export const mapSelectedTableAndService = (staticTriggerFields, surveyQuestionTriggers) => {
    let mappedTriggers = [];
    surveyQuestionTriggers.map((sqt) => {
        mappedTriggers.push({ 
            ...sqt,
            selectedService: staticTriggerFields.find(stf => stf.triggerServiceId === sqt.serviceFieldId)?.displayName || '',
            selectedTable: staticTriggerFields.find(stf => stf.triggerServiceId === sqt.serviceFieldId)?.tableDisplayName || ''
        });
    });

    return mappedTriggers;
}